import { AbstractControl, Validators, ValidatorFn } from '@angular/forms';

import { isPresent
} from '../../util/validation-functions';
export const gt = (value: number): ValidatorFn => {

  return (control: AbstractControl): {[key: string]: boolean} => {
    if (!isPresent(value)) {
      return null;
    }
    if (isPresent(Validators.required(control))) {
      return null;
    }
    const v: number = +control.value;
    return v > +value ? null : {nbvGt: true};
  };
};
